import { Button } from "@omni/ui/components/Button/button.component";

import { FormText } from "@/components/Form/Base/formText.component";
import { MultiFileUploadField } from "@/components/Form/RHF/FormFields/MultiUploadField/multiUploadField.component";
import { Col } from "@/components/General/Grid/col.component";
import { Row } from "@/components/General/Grid/row.component";
import { ModalType } from "@/redux/modules/value/modal/modal.types";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import { useModalRouter } from "@/utils/hooks/useModalRouter";

import {
    MAX_FILE_UPLOADS,
    WriteProgressiveReviewFormValues
} from "../writeReview.schema";
import { PhotoUploadField } from "./components/photoUploadField.component";

type MediaPartialProps = {
    disabled: boolean;
    staticPhotoUrls: Array<string>;
};

const MediaPartial = ({ disabled, staticPhotoUrls }: MediaPartialProps) => {
    const { t } = useGranite();

    const { open: openGuidanceModal } = useModalRouter(
        ModalType.ReviewPhotoGuidance
    );

    const handleOnGuidanceClick = () => {
        openGuidanceModal();
    };

    return (
        <Row>
            <Col>
                <MultiFileUploadField<WriteProgressiveReviewFormValues>
                    disabled={disabled}
                    name={"photos"}
                    label={t("product.reviews.form.photos.label")}
                    microCopy={({ amountOfFields }) => (
                        <div className="d-flex justify-content-between align-items-center">
                            <FormText
                                inline={true}
                                color="default"
                            >
                                {t(
                                    "product.reviews.form.photos.microcopy",
                                    amountOfFields,
                                    MAX_FILE_UPLOADS
                                )}
                            </FormText>
                            <Button
                                color="link"
                                size="sm"
                                onClick={handleOnGuidanceClick}
                            >
                                {t("product.reviews.form.photos.guidance")}
                            </Button>
                        </div>
                    )}
                    required={false}
                >
                    {({ actions, control, fields, name, disabled }) => (
                        <PhotoUploadField
                            actions={actions}
                            control={control}
                            fields={fields}
                            name={name}
                            disabled={disabled}
                            staticPhotoUrls={staticPhotoUrls}
                        />
                    )}
                </MultiFileUploadField>
            </Col>
        </Row>
    );
};

export { MediaPartial };
